<template>
  <div class="account-page" :class="{active: active}" :data-account-page="id">
    <div class="inner">
      <div class="form-section unlined">
        <lister-payment-details
            redirect-to="complete"
            :show-save-bank-account-details-button="false"
            ref="payment"
        ></lister-payment-details>
      </div>
      <div class="form-group vanilla submit">
        <div class="multi-action">
          <div class="form-action align-left">
            <button type="button" class="button muted" @click="navigateBack">
              <svg-icon id="arrowLeft"></svg-icon>
              <span>Back</span></button>
          </div>
          <div class="form-action align-right">
            <button type="button" class="button green" @click="navigateNext"><span>Save and Continue</span>
              <svg-icon id="arrowRight"></svg-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountSubpage from '../../../AccountSubpage'
import ListerPaymentDetails from '../main/subpages/PaymentDetails'

export default {
  extends: AccountSubpage,
  components: {
    ListerPaymentDetails
  },
  mounted () {
    this.$eventBus.$on('accountNavigate', mutation => {
      if (mutation.payload.page === 'profile-payment' && mutation.payload.pane === 'complete-profile') {
        this.$nextTick(() => {
          this.$refs.payment.getConnectAccount()
        })
      }
    })
  },
  data () {
    return {
      id: 'profile-payment'
    }
  },
  methods: {
    navigateBack () {
      this.$store.commit('account/navigateTo', { pane: 'complete-profile', page: 'profile-company' })
    },
    navigateNext () {
      this.$refs.payment.saveBankAccountDetails()
      this.$store.commit('user/setShouldCompleteProfile', false)
      this.$store.commit('account/navigateTo', { pane: 'complete-profile', page: 'profile-complete' })
    }
  }
}
</script>
